import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAthletePackage(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAthletePackage = (athletePackageId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`athlete-packages/${athletePackageId}/`);
  };

  return useMutation(deleteAthletePackage, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['athletePackages'],
      });
      queryClient.invalidateQueries('packages');
      queryClient.invalidateQueries('athleteSalesPortalPackages');
      queryClient.invalidateQueries('athleteSalesPortalPackage');
    },
  });
}
